import React, { useState } from "react";
import { photos } from "../data/photos";

/** Real photograph with a shimmer placeholder and fade-in. */
export default function Photo({ image, alt, className = "", style, hover = false, eager = false, position }) {
  const [loaded, setLoaded] = useState(false);
  const p = photos[image] || {};
  const src = `${process.env.PUBLIC_URL || ""}/images/photos/${p.file || image}`;

  return (
    <div className={`photo ${loaded ? "loaded" : ""} ${hover ? "photo--hover" : ""} ${className}`} style={style}>
      <img
        src={src}
        alt={alt || p.alt || ""}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
        decoding="async"
        width={p.width}
        height={p.height}
        style={{ objectPosition: position || p.position }}
        onLoad={() => setLoaded(true)}
      />
      {!loaded && <div className="photo__shimmer" aria-hidden="true" />}
    </div>
  );
}

/** Gradient initials avatar (used where we do not have a real portrait). */
export function Avatar({ name, className = "" }) {
  const initials = name.split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return <div className={`avatar ${className}`} aria-hidden="true">{initials}</div>;
}
